import Home from "./pages/Home/Home";
import "./App.css";

import { useSelector, useDispatch } from "react-redux/es/exports";

import LoginScreen from "./pages/Login/LoginScreen";
import { CircularProgress, useMediaQuery } from "@mui/material";
import { useEffect } from "react";
import { verifyAuth } from "./Redux/Actions";
import { loadFromDatabase } from "./Redux/Actions/fireactions";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { MediaQueryContext } from "./context/mediaQueryContext";
import { useTheme } from "@emotion/react";

function App() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const databaseLoading = useSelector((state) => state.job.databaseLoading);
  const userAuthorized = useSelector((state) => state.user.userAuthorized);
  const loading = useSelector((state) => state.user.verifying);

  const [online, setOnline] = useState(navigator.onLine);

  const theme = useTheme();
  const screenXS_UP = useMediaQuery(theme.breakpoints.up("xs"));
  const screenSM_UP = useMediaQuery(theme.breakpoints.up("sm"));
  const screenMD_UP = useMediaQuery(theme.breakpoints.up("md"));
  const screenLG_UP = useMediaQuery(theme.breakpoints.up("lg"));
  const screenXL_UP = useMediaQuery(theme.breakpoints.up("xl"));
  const screenXS_DOWN = useMediaQuery(theme.breakpoints.down("xs"));
  const screenSM_DOWN = useMediaQuery(theme.breakpoints.down("sm"));
  const screenMD_DOWN = useMediaQuery(theme.breakpoints.down("md"));
  const screenLG_DOWN = useMediaQuery(theme.breakpoints.down("lg"));
  const screenXL_DOWN = useMediaQuery(theme.breakpoints.down("xl"));

  useEffect(() => {
    dispatch(verifyAuth());
    if (userAuthorized) {
      dispatch(loadFromDatabase());
    }

    return () => {};
  }, [userAuthorized]);

  useEffect(() => {
    function changeStatus() {
      setOnline(navigator.onLine);
    }
    // console.log("navigator :>> ", navigator);
    window.addEventListener("online", changeStatus);
    window.addEventListener("offline", changeStatus);
    return () => {
      window.removeEventListener("online", changeStatus);
      window.removeEventListener("offline", changeStatus);
    };
  }, []);

  return (
    <MediaQueryContext.Provider
      value={[
        screenXS_UP,
        screenSM_UP,
        screenMD_UP,
        screenLG_UP,
        screenXL_UP,
        screenXS_DOWN,
        screenSM_DOWN,
        screenMD_DOWN,
        screenLG_DOWN,
        screenXL_DOWN,
      ]}
    >
      <div className="App">
        {online ? null : (
          <div className="offline-text">
            {t("You are Offline ! Please check internet connection")}
          </div>
        )}
        {loading || databaseLoading ? (
          <div className="main-loading">
            <CircularProgress color="primary" />
          </div>
        ) : userAuthorized ? (
          <Home />
        ) : (
          <LoginScreen />
        )}
      </div>
    </MediaQueryContext.Provider>
  );
}

export default App;
